const authTypesMap = {
  custom: 'Custom',
  oAuth2: 'OAuth 2',
  oAuth1: 'OAuth 1',
  basic: 'Basic',
  apiKey: 'API Key',
  none: 'None'
};

export default authTypesMap;
